import { Component, Output, EventEmitter } from '@angular/core';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'legacy-topbar',
  templateUrl: './legacy-topbar.component.html',
  styleUrls: ['./legacy-topbar.component.css']
})
export class LegacyTopbarComponent {
  currentOption: string = 'home';

  constructor(public auth: AuthService) { }

  @Output() onNavigationEvent = new EventEmitter<string>();

  onNavigation($event: Event) {
    const target = ($event.target || $event.srcElement) as HTMLElement;
    const label = target.closest ? target.closest('[data-value]') as HTMLElement : null;
    const value = label ? label.getAttribute('data-value') : null;
    if (value) {
      this.currentOption = value;
      this.onNavigationEvent.emit(value);
    }
  }
}
